import { supabase } from '../utils/supabase';

/**
 * Load the current player's club join requests (SECURITY DEFINER RPC).
 * Direct table SELECT is blocked for non-admins by RLS.
 */
export async function getMyClubJoinRequests() {
  const { data, error } = await supabase.rpc('get_my_club_join_requests');
  if (error) throw error;

  return (data || []).map((row) => ({
    id: row.request_id,
    request_id: row.request_id,
    club_id: row.club_id,
    status: row.status,
    cooldown_until: row.cooldown_until,
    is_blocked: row.is_blocked,
    rejection_message: row.rejection_message,
    created_at: row.created_at,
    updated_at: row.updated_at,
  }));
}
